import { render, staticRenderFns } from "./MessageParsing.vue?vue&type=template&id=3106777a&scoped=true"
import script from "./MessageParsing.vue?vue&type=script&lang=js"
export * from "./MessageParsing.vue?vue&type=script&lang=js"
import style0 from "./MessageParsing.vue?vue&type=style&index=0&id=3106777a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106777a",
  null
  
)

export default component.exports